import React, { forwardRef } from 'react'

import cn from 'classnames'

import styles from './PrimaryButton.module.scss'
import { PrimaryButtonProps } from './types'
import BaseButton from '../BaseButton'

const PrimaryButton: React.FC<PrimaryButtonProps> = forwardRef(
  ({ className, children, isDisabled, isLoading, isSelected, isReverse, ...props }, ref) => (
    <BaseButton
      className={cn(
        styles.primaryButton,
        (isDisabled || isLoading) && styles.primaryButton_disabled,
        isLoading && styles.primaryButton_isLoading,
        isSelected && styles.primaryButton_selected,
        isReverse && styles.primaryButton_reverse,
        className,
      )}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isSelected={isSelected}
      styles={styles}
      ref={ref}
      {...props}
    >
      {children}
    </BaseButton>
  ),
)

export default PrimaryButton
